module.exports = __webpack_public_path__ + "img/banner1.19eae932.png";